import React, { Fragment, useEffect, useRef, useState } from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import DragDrop from "../DragDrop/DragDrop";
import ApprovalsScreen from "./ApprovalsScreen";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import moment from "moment";
import { useGlobalState } from "../Context/GlobalStateContext";
import Confirmation from "../App/Confirmation";
import { getAccessSettings } from "../Shared/Utility";
function Exceptions() {
  const globalState = useGlobalState();
  const [showAnimation, setShowAnimation] = useState(false);

  const [programList, setProgramList] = useState<any>([]);
  const [quarterList, setQuarterList] = useState<any>([]);

  const [exceptionStatusList, setExceptionStatusList] = useState<any>([
    {
      PID: -1,
      Name: "All",
    },
    {
      PID: 0,
      Name: "Pending Approval",
    },
    {
      PID: 1,
      Name: "Approved",
    },
    {
      PID: 2,
      Name: "Rejected",
    },
  ]);

  const [groupList, setGroupList] = useState<any>([]);

  const [exceptionDataFilter, setExceptionDataFilter] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    PFIDealerID: 0,
    IBBScorecardID: 0,
    PFIGroupIDs: "1",
    ExceptionStatusID: -1,
    ExceptionID: -1,
    SectionID: 0,
    IBBDepartmentID: 0,
  });

  const [exceptionsData, setExceptionsData] = useState<any>([]);
  const [exceptionsDocuments, setExceptionsDocuments] = useState<any>([]);

  const [sectionsList, setSectionsList] = useState<any>([]);

  //MM:: Approval related data
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  const [conditionModal, setConditionModal] = useState(false);
  const [conditionData, setConditionData] = useState<any>({});

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = exceptionDataFilter.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = exceptionDataFilter.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = exceptionDataFilter.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = exceptionDataFilter.ProgramID;

    let ExceptionStatusID = params.get("exsid") as any;
    if (ExceptionStatusID && ExceptionStatusID != "")
      ExceptionStatusID = Number(ExceptionStatusID);
    else ExceptionStatusID = exceptionDataFilter.ExceptionStatusID;

    let ExceptionID = params.get("exid") as any;
    if (ExceptionID && ExceptionID != "") ExceptionID = Number(ExceptionID);
    else ExceptionID = exceptionDataFilter.ExceptionID;

    setExceptionDataFilter((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
      ExceptionStatusID: ExceptionStatusID,
      ExceptionID: ExceptionID,
    }));

    IBBProgramGetProgramListForScorecard(IBBProgramID, QuarterID);
    IBBGroupGetCompleteGridData();
  }, []);

  useEffect(() => {
    if (exceptionDataFilter.ProgramID > 0)
      IBBProgramCriteriaQuestionInputExceptionGetDataForApproval();
  }, [exceptionDataFilter]);

  useEffect(() => {
    if (exceptionDataFilter.ProgramID > 0)
      IBBProgramGetSectionAndCriteriaDataForScorecard(
        exceptionDataFilter.ProgramID
      );
  }, [exceptionDataFilter.ProgramID]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = exceptionDataFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = exceptionDataFilter.QuarterID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setExceptionDataFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }
          }

          setQuarterList(result[2]);
          if (QuarterID == 0) {
            let QuarterID = result[2][0].PID;
            setExceptionDataFilter((prevState: any) => ({
              ...prevState,
              QuarterID: QuarterID,
            }));
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupGetCompleteGridData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 1000;
    object.sortexpressions = "Description";
    object.sortdirection = "D";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBGroup/IBBGroupGetCompleteGridData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            if (result[1].length > 0) {
            }

            setGroupList(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetSectionAndCriteriaDataForScorecard(
    IBBProgramID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = exceptionDataFilter.ProgramID;

    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = IBBProgramID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetSectionAndCriteriaDataForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          var filtered = result[0].filter((item: any) => item.Type == 2);
          let sectionsListLocal = [] as any;

          for (let i = 0; i < filtered.length; i++) {
            let section = filtered[i];
            if (getAccessSettings(1, section.IBBDepartmentID) > 0)
              sectionsListLocal.push(section);
          }

          setSectionsList(sectionsListLocal);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramCriteriaQuestionInputExceptionGetDataForApproval() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = exceptionDataFilter.ProgramID;
    object.quarterid = exceptionDataFilter.QuarterID;
    object.pfigroupids = exceptionDataFilter.PFIGroupIDs;
    object.exceptionstatusid = exceptionDataFilter.ExceptionStatusID;
    object.exceptionid = exceptionDataFilter.ExceptionID;
    object.ibbprogramstageid = 10;
    object.ibbprogramsectionid = exceptionDataFilter.SectionID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramCriteriaQuestionInputException/IBBProgramCriteriaQuestionInputExceptionGetDataForApproval",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;

          if (result.length > 2) {
            let exceptionsDataLocal = [];
            var filtered = result[0].filter((item: any) => item.Type == 1);
            if (filtered.length > 0)
              exceptionsDataLocal.push({
                SectionTypeName: "GATEWAY EXCEPTIONS",
                Data: filtered,
              });

            var filtered = result[0].filter((item: any) => item.Type == 2);
            if (filtered.length > 0)
              exceptionsDataLocal.push({
                SectionTypeName: "CRITERIA EXCEPTIONS",
                Data: filtered,
              });

            setExceptionsData(exceptionsDataLocal);
            setExceptionsDocuments(result[1]);
            setRequiredApprovalUser(result[2]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBConditionSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbconditionid = conditionData.IBBConditionID;
    object.ibbscorecardid = conditionData.IBBScorecardID;
    object.ibbprogramcriteriaquestioninputexceptionid =
      conditionData.IBBProgramCriteriaQuestionInputExceptionID;
    object.name = conditionData.Name;
    object.name = conditionData.Deadline;
    object.conditiontext = conditionData.ConditionText;
    object.amount = conditionData.Amount;
    object.status = conditionData.Status;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBCondition/IBBConditionSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setConditionModal(false);
          IBBProgramCriteriaQuestionInputExceptionGetDataForApproval();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBConditionDeleteRecordCustom(IBBConditionID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbconditionid = IBBConditionID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBCondition/IBBConditionDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBProgramCriteriaQuestionInputExceptionGetDataForApproval();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function triggerApprovalParent() {
    IBBProgramCriteriaQuestionInputExceptionGetDataForApproval();
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBConditionDeleteRecordCustom(obj.SelectedID);
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>exceptions status</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items">
              <select
                value={exceptionDataFilter.ProgramID}
                onChange={(e) => {
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                    IBBScorecardID: 0,
                    ExceptionID: -1,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(
                    Number(e.target.value),
                    0
                  );
                }}
              >
                {programList &&
                  programList.map((item: any, index: any) => (
                    <option value={item.PID} key={"programoption" + item.PID}>
                      {item.Name}
                    </option>
                  ))}
              </select>

              <select
                value={exceptionDataFilter.QuarterID}
                onChange={(e) => {
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                    ExceptionID: -1,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                }}
              >
                {quarterList &&
                  quarterList.map((item: any, index: any) => (
                    <option value={item.PID} key={"quarteroption" + item.PID}>
                      {item.Name}
                    </option>
                  ))}
              </select>

              <select
                value={exceptionDataFilter.SectionID}
                onChange={(e) => {
                  let SectionID = Number(e.target.value);

                  let IBBDepartmentID = 0;
                  let filtered = sectionsList.filter(
                    (item: any) => item.SectionID == SectionID
                  );

                  if (filtered.length > 0) {
                    IBBDepartmentID = filtered[0].IBBDepartmentID;
                  }

                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    SectionID: SectionID,
                    IBBDepartmentID: IBBDepartmentID,
                    ExceptionID: -1,
                  }));
                }}
              >
                <option value={0} key={"section" + 0}>
                  All
                </option>
                {sectionsList &&
                  sectionsList.map((Item: any, index: any) => (
                    <option
                      value={Item.SectionID}
                      key={"section" + Item.SectionID}
                    >
                      {Item.Title}
                    </option>
                  ))}
              </select>

              <select
                value={exceptionDataFilter.ExceptionStatusID}
                onChange={(e) =>
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    ExceptionStatusID: Number(e.target.value),
                    ExceptionID: -1,
                  }))
                }
              >
                {exceptionStatusList &&
                  exceptionStatusList.map((item: any, index: any) => (
                    <option
                      value={item.PID}
                      key={"exceptionStatusList" + item.PID}
                    >
                      {item.Name}
                    </option>
                  ))}
              </select>
              <select
                value={exceptionDataFilter.PFIGroupIDs}
                onChange={(e) =>
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    PFIGroupIDs: Number(e.target.value),
                    ExceptionID: -1,
                  }))
                }
              >
                {groupList &&
                  groupList.map((item: any, index: any) => (
                    <option value={item.IBBGroupID} key={"groupoption" + index}>
                      {item.Name}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="section-table mb-10 exception-up">
            {exceptionsData &&
              exceptionsData.map((item: any, index: any) => (
                <React.Fragment key={item.SectionTypeName}>
                  <span className="buis-head font-16">
                    {item.SectionTypeName}
                  </span>
                  {item.Data &&
                    item.Data.map((itemException: any, indexException: any) => (
                      <React.Fragment
                        key={
                          itemException.IBBProgramCriteriaQuestionInputExceptionID
                        }
                      >
                        <div className="buis-case case-back plr-20">
                          <div className="excep-heading">
                            <span>
                              {itemException.PTOrderBy}.{itemException.Title} -{" "}
                              {itemException.Name}
                            </span>
                            <div className="flex-items">
                              <span>{itemException.Importer}</span>
                              {itemException.ConditionText == "" &&
                                getAccessSettings(2, 27) > 1 && (
                                  <a
                                    onClick={() => {
                                      let conditionDataLocal = {} as any;
                                      conditionDataLocal.IBBScorecardID =
                                        itemException.IBBScorecardID;
                                      conditionDataLocal.IBBProgramCriteriaQuestionInputExceptionID =
                                        itemException.IBBProgramCriteriaQuestionInputExceptionID;
                                      conditionDataLocal.Amount =
                                        itemException.FinancialValue;
                                      conditionDataLocal.Status = 0;

                                      setConditionData(conditionDataLocal);
                                      setConditionModal(true);
                                    }}
                                    className="btn-primary btn-condition"
                                    title="Add Condition"
                                  >
                                    Conditional Hold
                                  </a>
                                )}
                            </div>
                          </div>
                          <div className="exception-grid">
                            <div className="exceptions-left">
                              <div className="flex-items buis-head">
                                <span>
                                  Financial Value:{" "}
                                  {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                    -1
                                  )}
                                  {itemException.FinancialValue.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                    }
                                  )}
                                </span>{" "}
                                <span>
                                  Approved Value:{" "}
                                  {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                    -1
                                  )}
                                  {itemException.ApprovedValue.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 0,
                                    }
                                  )}
                                </span>{" "}
                                <span
                                  className={`
                               ${itemException.Status == 1 ? "sig-green" : ""}
                               ${itemException.Status == 2 ? "sig-red" : ""}
                          `}
                                >
                                  Status: {itemException.StatusName}
                                </span>
                              </div>
                              <span>
                                <b>Business Case:</b>
                              </span>
                              <span className="flex-items">
                                <span className="b-excep-wrap">
                                  {itemException.BusinessCase}
                                </span>
                              </span>
                              <div className="flex-items supp-doc">
                                <span>Supporting Documents:</span>
                                <>
                                  {exceptionsDocuments &&
                                    exceptionsDocuments.map(
                                      (
                                        ItemAttachment: any,
                                        indexAttachment: any
                                      ) => (
                                        <>
                                          {itemException.IBBProgramCriteriaQuestionInputID ==
                                            ItemAttachment.ObjectID && (
                                            <span
                                            title={ItemAttachment.Name}
                                              key={
                                                ItemAttachment.ObjectID +
                                                "" +
                                                indexAttachment
                                              }
                                            >
                                              <a
                                                href={ItemAttachment.FileURLRaw}
                                                target="blank"
                                              >
                                                <img
                                                  src="images/pdf.svg"
                                                  width="40px"
                                                  height="40px"
                                                />
                                              </a>
                                            </span>
                                          )}
                                        </>
                                      )
                                    )}
                                </>
                              </div>
                              {itemException.ConditionText != "" && (
                                <>
                                  <span>
                                    <b>Condition:</b>{" "}
                                    <span className="added-by-txt">
                                      Added by{" "}
                                      {itemException.ConditionAddedByName} on{" "}
                                      {moment(itemException.AddedOnTime).format(
                                        "DD/MM/YYYY HH:MM"
                                      )}
                                    </span>
                                  </span>
                                  <div className="flex-items">
                                    <span className="spn-text-width">
                                      {itemException.ConditionText}
                                    </span>
                                    {itemException.ConditionStatus == 0 &&
                                      getAccessSettings(2, 27) > 1 && (
                                        <>
                                          <a
                                            className="btn-primary btn-grid"
                                            onClick={() => {
                                              let conditionDataLocal =
                                                {} as any;
                                              conditionDataLocal.IBBConditionID =
                                                itemException.IBBConditionID;
                                              conditionDataLocal.IBBScorecardID =
                                                itemException.IBBScorecardID;
                                              conditionDataLocal.IBBProgramCriteriaQuestionInputExceptionID =
                                                itemException.IBBProgramCriteriaQuestionInputExceptionID;
                                              conditionDataLocal.Amount =
                                                itemException.FinancialValue;
                                              conditionDataLocal.Status = 0;
                                              conditionDataLocal.ConditionText =
                                                itemException.ConditionText;
                                              conditionDataLocal.Deadline =
                                                itemException.Deadline;
                                              setConditionData(
                                                conditionDataLocal
                                              );
                                              setConditionModal(true);
                                            }}
                                            title={"Edit"}
                                          >
                                            <img
                                              src="images/edit.svg"
                                              width={15}
                                              height={15}
                                            />
                                          </a>

                                          <a
                                            className="btn-primary btn-grid"
                                            onClick={() => {
                                              globalState.setConfirmationObject(
                                                {
                                                  ShowPopup: true,
                                                  Heading: "Confirmation ",
                                                  Message:
                                                    "Are you sure you want to delete this record?",
                                                  ID: 1,
                                                  SelectedID:
                                                    itemException.IBBConditionID,
                                                }
                                              );
                                            }}
                                            title="Delete"
                                          >
                                            <img
                                              src="images/delete.svg"
                                              width={15}
                                              height={15}
                                            />
                                          </a>
                                        </>
                                      )}
                                  </div>
                                  <span>
                                    <b>Deadline:</b>
                                  </span>
                                  <div className="flex-items">
                                    <span className="spn-text-width">
                                      {moment(itemException.Deadline).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="pg-importers appr-grid grid-signoff">
                              <div className="appr-main">
                                <div className="exceptions-right">
                                  <div className="req-by">
                                    <div className="req-left">
                                      <span className="req-title show-block">
                                        Requested By
                                      </span>
                                      <span className="req-val">
                                        {itemException.RequestedBy}
                                      </span>
                                    </div>
                                    <div className="req-right"></div>
                                  </div>
                                  <span
                                    className="req-title"
                                    style={{ paddingLeft: 10, marginBottom: 5 }}
                                  >
                                    Operational Approval
                                  </span>
                                  <div className="excp-approval">
                                    <ApprovalsScreen
                                      approvalObjectType={17}
                                      IBBProgramID={
                                        exceptionDataFilter.ProgramID
                                      }
                                      QuarterID={exceptionDataFilter.QuarterID}
                                      IBBProgramSectionID={0}
                                      ApprovalTextType={1}
                                      approvalObjectID={
                                        itemException.IBBProgramCriteriaQuestionInputExceptionID
                                      }
                                      uploadObjectType={
                                        AppContext.FileUploadObjectTypeExceptionApprovalFile
                                      }
                                      requiredApprovalUser={
                                        requiredApprovalUser
                                      }
                                      triggerApprovalParent={
                                        triggerApprovalParent
                                      }
                                    ></ApprovalsScreen>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>
      {conditionModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Condition</h3>
                <a
                  className="close-help"
                  onClick={() => setConditionModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              <div className="buis-case plr-20">
                <span className="buis-head">Condition:</span>
                <textarea
                  value={conditionData.ConditionText}
                  onChange={(e) => {
                    setConditionData((prevState: any) => ({
                      ...prevState,
                      ConditionText: e.target.value,
                    }));
                  }}
                ></textarea>
              </div>
              <div className="buis-case plr-20">
                <span className="buis-head">Deadline:</span>
                <input
                  type="date"
                  value={moment(conditionData.Deadline).format("YYYY-MM-DD")}
                  onChange={(e) => {
                    setConditionData((prevState: any) => ({
                      ...prevState,
                      Deadline: e.target.value,
                    }));
                  }}
                ></input>
              </div>
              <div className="help-btns">
                <a
                  onClick={() => {
                    IBBConditionSaveCustom();
                  }}
                >
                  Save
                </a>
                <a onClick={() => setConditionModal(false)}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default Exceptions;
